
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Calendar, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get payment status from URL params
    const paymentId = searchParams.get('payment_id');
    const status = searchParams.get('status');
    const externalReference = searchParams.get('external_reference');

    console.log('Payment success page params:', { paymentId, status, externalReference });

    if (status === 'approved') {
      toast.success('Pagamento aprovado! Sua consulta foi confirmada.');
    } else if (status === 'pending') {
      toast.info('Pagamento está sendo processado. Você receberá uma confirmação em breve.');
    } else {
      toast.error('Houve um problema com o pagamento. Tente novamente.');
    }

    setIsLoading(false);
  }, [searchParams]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-8 animate-fade-in">
      <div className="text-center">
        <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-green-600">Pagamento Realizado!</h1>
        <p className="text-muted-foreground mt-2">
          Sua consulta foi agendada com sucesso
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
            Consulta Confirmada
          </CardTitle>
          <CardDescription>
            Você receberá um e-mail de confirmação com todos os detalhes
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <h3 className="font-medium text-green-800 mb-2">O que acontece agora?</h3>
            <ul className="text-sm text-green-700 space-y-1">
              <li>• Você receberá um e-mail de confirmação</li>
              <li>• O psicólogo será notificado sobre o agendamento</li>
              <li>• Um link do Google Meet será gerado automaticamente</li>
              <li>• Você receberá lembretes antes da consulta</li>
            </ul>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-primary" />
              <span className="text-sm">
                Acesse suas consultas agendadas no seu dashboard
              </span>
            </div>
            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-primary" />
              <span className="text-sm">
                Lembre-se: consultas podem ser reagendadas com 24h de antecedência
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild className="flex-1">
              <Link to="/patient-dashboard">
                Ver Minhas Consultas
              </Link>
            </Button>
            <Button variant="outline" asChild className="flex-1">
              <Link to="/schedule">
                Agendar Nova Consulta
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
